import type { SVGAttributes } from 'react';
import type { ChakraProps } from '@chakra-ui/react';
import { chakra } from '@chakra-ui/react';

const Svg = chakra('svg');

type Props = Omit<SVGAttributes<SVGElement>, keyof ChakraProps> & ChakraProps;

export const CitizenIllustration = (props: Props) => (
  <Svg viewBox='0 0 179 173' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
    <g clipPath='url(#clip0_895_14509)'>
      <circle cx={101} cy={91} r={63} fill='#F9EFE2' />
      <circle cx={109} cy={86} r={62.25} stroke='#F0D4B2' strokeWidth={1.5} />
      <mask
        id='mask0_895_14509'
        style={{
          maskType: 'alpha',
        }}
        maskUnits='userSpaceOnUse'
        x={37}
        y={-8}
        width={128}
        height={163}>
        <path
          d='M37.5873 90.4941C37.5873 125.599 66.1096 154.057 101.294 154.057C111.142 154.057 120.469 151.828 128.794 147.846H165V-7.49701H37.5873V90.4941Z'
          fill='#F9EFE2'
        />
      </mask>
      <g mask='url(#mask0_895_14509)'>
        <path
          d='M117.016 37.7709C110.82 37.4386 99.5333 39.5433 96.435 44.0852L103.351 71.7181L86.1443 143.12C79.7264 155.084 55.0509 155.86 54.055 135.144C53.0591 114.429 65.8949 111.106 67.6653 99.0309C69.4358 86.9561 57.7066 80.8634 60.1409 68.7886C62.5753 56.7139 79.8371 53.8336 82.8247 40.208C85.8124 26.5823 94.3326 15.9477 108.717 15.0615C123.102 14.1753 133.393 23.026 133.393 31.5673C133.393 40.208 124.651 36.8847 124.651 33.0075C124.172 34.706 121.974 38.0368 117.016 37.7709Z'
          fill='#D8601E'
        />
        <path
          d='M117.736 110.49C120.17 114.921 123.047 117.58 123.49 120.46C123.844 122.764 121.719 127.624 120.613 129.766'
          stroke='black'
        />
        <path
          d='M130.959 38.8786C130.959 61.2557 117.791 77.6509 109.271 71.0042L111.041 82.5251C112.425 88.3348 115.634 92.3228 119.728 96.3108L138.539 115.032L141.582 100.576L159.397 104.508C155.856 116.103 151.153 129.943 149.383 135.969C147.17 143.502 135.219 144.388 130.572 139.957C126.854 136.412 121.867 131.132 120.613 129.876L128.027 176.181C112.978 180.723 72.0364 179.394 59.2557 174.914C64.8621 152.906 76.3405 107.915 77.4027 104.016C78.7306 99.1417 81.1649 96.483 84.4845 94.2675C87.8041 92.0519 93.3367 88.9501 96.4351 80.0879C99.0907 71.3144 98.9802 64.5791 96.4351 56.8246C96.2138 58.7448 93.115 58.7079 91.3448 54.6091C87.2475 45.1222 92.6728 41.5373 96.4351 43.9744V38.8786C96.4351 16.3908 130.959 16.5015 130.959 38.8786Z'
          fill='#DDA98C'
        />
        <ellipse
          opacity={0.2}
          cx={111.429}
          cy={53.8829}
          rx={0.553263}
          ry={0.553888}
          fill='#A43900'
        />
        <ellipse opacity={0.2} cx={125.15} cy={49.895} rx={0.553265} ry={0.553888} fill='#A43900' />
        <ellipse
          opacity={0.2}
          cx={107.003}
          cy={53.2183}
          rx={0.553265}
          ry={0.553886}
          fill='#A43900'
        />
        <ellipse
          opacity={0.2}
          cx={122.605}
          cy={53.2183}
          rx={0.663918}
          ry={0.553886}
          fill='#A43900'
        />
        <ellipse opacity={0.2} cx={109.88} cy={49.895} rx={0.553265} ry={0.553888} fill='#A43900' />
        <path
          d='M117.016 37.7709C110.82 37.4386 99.5333 39.5433 96.435 44.0852L89.6302 38.2633L82.8247 40.208C85.8123 26.5823 94.3326 15.9477 108.717 15.0615C123.102 14.1753 133.393 23.026 133.393 31.5673C133.393 40.208 124.651 36.8847 124.651 33.0075C124.172 34.706 121.974 38.0368 117.016 37.7709Z'
          fill='#D8601E'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M100.806 95.8677C106.542 95.8677 112.069 95.1296 117.257 93.7619C118.035 94.623 118.861 95.4669 119.728 96.3108L138.539 115.032L141.526 100.41L159.784 104.287C157.856 110.6 155.469 117.645 153.408 123.725L153.408 123.726C151.684 128.812 150.189 133.224 149.383 135.969C147.17 143.502 135.219 144.388 130.572 139.957C127.871 137.382 124.501 133.892 122.378 131.693L122.378 131.693C121.579 130.865 120.956 130.22 120.613 129.876L128.027 176.181C112.978 180.723 72.0364 179.394 59.2557 174.914C64.8621 152.906 76.3405 107.915 77.4027 104.016C78.7306 99.1417 81.1649 96.483 84.4845 94.2675C84.6506 94.1567 84.8222 94.0436 84.9987 93.9277C89.9991 95.1891 95.3068 95.8677 100.806 95.8677Z'
          fill='#50B2C2'
        />
        <mask
          id='mask1_895_14509'
          style={{
            maskType: 'alpha',
          }}
          maskUnits='userSpaceOnUse'
          x={59}
          y={93}
          width={101}
          height={86}>
          <path
            d='M117.257 93.7619C112.069 95.1296 106.542 95.8677 100.806 95.8677C95.3068 95.8677 89.9991 95.1891 84.9987 93.9277C84.8222 94.0436 84.6506 94.1567 84.4845 94.2675C81.1649 96.483 78.7306 99.1417 77.4027 104.016C76.3405 107.915 64.8621 152.906 59.2557 174.914C72.0364 179.394 112.978 180.723 128.027 176.181L120.613 129.876C120.956 130.22 121.579 130.865 122.378 131.693C124.501 133.892 127.871 137.382 130.572 139.957C135.219 144.388 147.17 143.502 149.383 135.969C150.189 133.224 151.684 128.812 153.408 123.726C155.469 117.645 157.856 110.6 159.784 104.287L141.526 100.41L138.539 115.032L119.728 96.3108C118.861 95.4669 118.035 94.623 117.257 93.7619Z'
            fill='#50B2C2'
          />
        </mask>
        <g mask='url(#mask1_895_14509)'>
          <path
            d='M118.179 112.041C120.317 116.065 122.845 118.479 123.234 121.094C123.545 123.187 121.679 127.599 120.706 129.544'
            stroke='#014558'
          />
        </g>
        <path d='M135.994 126.221L138.649 114.921' stroke='#014558' />
        <ellipse
          rx={9.38356}
          ry={4.23477}
          transform='matrix(0.974872 0.222768 -0.222291 0.97498 150.694 102.257)'
          fill='#006D86'
        />
        <mask
          id='mask2_895_14509'
          style={{
            maskType: 'alpha',
          }}
          maskUnits='userSpaceOnUse'
          x={131}
          y={49}
          width={46}
          height={58}>
          <path
            d='M149.31 106.386C154.362 107.54 158.879 106.627 159.399 104.347L176.714 82.0759L162.827 49.895L131.512 66.0131L141.104 100.166C140.584 102.447 144.258 105.231 149.31 106.386Z'
            fill='#006D86'
          />
        </mask>
        <g mask='url(#mask2_895_14509)'>
          <path
            d='M147.615 93.0809L143.266 113.124C145.368 114.509 150.476 115.863 152.597 115.214C153.879 110.07 161.339 78.3654 160.334 77.9223C159.53 77.5678 157.9 81.6184 157.185 83.688C157.883 80.3691 159.076 73.6944 158.26 73.5459C157.445 73.3974 155.522 79.6356 154.663 82.7733C155.487 78.7297 156.904 70.6297 155.98 70.5785C155.057 70.5273 152.936 78.33 151.991 82.2378C152.598 79 153.562 72.4331 152.553 72.0673C151.544 71.7014 148.893 80.6617 147.668 85.7592C146.962 82.2334 145.479 80.7599 143.967 80.7599C143.967 84.211 143.503 91.2996 147.615 93.0809Z'
            fill='#DDA98C'
          />
        </g>
        <path d='M86.0893 126.221L78.0117 177.954' stroke='#014558' />
        <path
          d='M117.238 49.5133C116.684 52.9474 119.451 54.2768 119.451 55.8276C119.451 57.062 116.426 57.1939 115.246 56.7139'
          stroke='#014558'
          strokeWidth={0.5}
        />
        <path
          d='M104.873 61.5992C105.677 60.1624 106.761 59.2158 108.51 58.8643'
          stroke='#014558'
          strokeWidth={0.5}
        />
        <path
          d='M114.113 65.7892C112.967 65.6708 112.045 65.2417 110.9 63.2303C111.572 62.9655 113.047 62.4496 113.582 62.5048C114.251 62.5738 114.206 63.0146 114.397 63.0343C114.588 63.054 114.634 62.6133 115.302 62.6823C115.837 62.7375 117.177 63.5439 117.78 63.9402C116.25 65.6755 115.26 65.9075 114.113 65.7892Z'
          fill='#D8601E'
        />
        <path
          d='M110.9 63.2303C111.535 63.6299 113.592 64.2876 114.261 64.3566C114.93 64.4257 117.077 64.2018 117.78 63.9402'
          stroke='#014558'
          strokeWidth={0.5}
        />
        <ellipse cx={94.9415} cy={56.2093} rx={0.885221} ry={0.886221} fill='#A43900' />
        <ellipse
          cx={108.441}
          cy={44.4668}
          rx={8.1883}
          ry={8.19755}
          stroke='#014558'
          strokeWidth={0.5}
        />
        <ellipse
          cx={125.482}
          cy={44.4669}
          rx={7.967}
          ry={7.97599}
          stroke='#014558'
          strokeWidth={0.5}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M112.922 46.8547C113.35 46.8547 113.697 45.9123 113.697 44.7499C113.697 43.5875 113.35 42.6451 112.922 42.6451C112.499 42.6451 112.155 43.568 112.148 44.7138C112.2 44.6973 112.256 44.6884 112.314 44.6884C112.62 44.6884 112.867 44.9364 112.867 45.2423C112.867 45.5482 112.62 45.7962 112.314 45.7962C112.292 45.7962 112.271 45.7949 112.249 45.7924C112.383 46.427 112.634 46.8547 112.922 46.8547Z'
          fill='#014558'
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M120.889 46.8547C121.317 46.8547 121.664 45.9123 121.664 44.7499C121.664 43.5875 121.317 42.6451 120.889 42.6451C120.466 42.6451 120.122 43.568 120.115 44.7138C120.167 44.6973 120.223 44.6884 120.281 44.6884C120.587 44.6884 120.834 44.9364 120.834 45.2423C120.834 45.5482 120.587 45.7962 120.281 45.7962C120.259 45.7962 120.237 45.7949 120.216 45.7924C120.35 46.427 120.601 46.8547 120.889 46.8547Z'
          fill='#014558'
        />
      </g>
      <circle cx={8} cy={46} r={8} fill='#D8601E' />
    </g>
    <defs>
      <clipPath id='clip0_895_14509'>
        <rect width={179} height={173} fill='white' />
      </clipPath>
    </defs>
  </Svg>
);
